export default __webpack_public_path__ + "images/49b88256170809fd49e78e52f5421b9f-libpythia.browser.wasm";